import { useFormContext, useWatch } from "react-hook-form";
import { usePricingTabContext } from "../../hooks/usePricingTabContext";
import { useSubscriptionGroup } from "../../hooks/useSubscriptionGroup";
import { SubscriptionGroupSelect } from "../Fields/SubscriptionGroupSelect";
import { SubscriptionGroupToggle } from "../Fields/SubscriptionGroupToggle";
import { ToggleableField } from "../ToggleableField";

export const SubscriptionGroupForm = () => {
  const { currency } = usePricingTabContext();
  const { watch } = useFormContext();
  const { control } = useFormContext();
  const id = useWatch({ control, name: "id" });

  const {
    canShowChooser,
    canEnableChooser,
    paywallGroupSelectOptions,
    isSubscriptionGroupEnabled,
  } = useSubscriptionGroup(currency);

  const isToggleDisabled = !canShowChooser || !canEnableChooser;
  const isSelectDisabled = isToggleDisabled || !isSubscriptionGroupEnabled;
  let tooltipText = "create_a_paywall_first";
  if (id) {
    tooltipText = isToggleDisabled
      ? "paywall_group_tooltip_disabled"
      : "paywall_group_tooltip";
  }

  const isSubscriptionGroupEnabledFromForm = watch("enable_subscription_group");

  return (
    <ToggleableField
      toggleField={
        <SubscriptionGroupToggle
          tooltipText={tooltipText}
          isToggleDisabled={isToggleDisabled}
          enableSubscriptionGroup={isSubscriptionGroupEnabled}
        />
      }
      fieldToggleable={
        <SubscriptionGroupSelect
          isSelectDisabled={isSelectDisabled}
          paywallGroupSelectOptions={paywallGroupSelectOptions}
          className="w-7/12"
        />
      }
      hideToggleableField={!isSubscriptionGroupEnabledFromForm}
    />
  );
};
